import React, { useState } from "react";
import { motion } from "framer-motion";

import classes from "./Contacto.module.css";

const Contacto = () => {

  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const data = new FormData(form);

    try {
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data).toString(),
      });

      setEnviado(true);
      form.reset();
    } catch (error) {
      alert("Hubo un error. Intentalo más tarde.");
    }
  };

  return (
    <section id="contacto" className={classes.contacto}>
      <div className={classes.container}>
        <motion.h2 
          className={classes.titulo}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          >
            Contáctanos
        </motion.h2>
        <motion.p
          className={classes.subtitulo}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          viewport={{ once: true }}
          >
            Estamos disponibles para ayudarte y conectar tu marca con el público.
        </motion.p>

        {/**to do: validar Formulario */}

        {!enviado ? (
          <form
            name="contacto"
            method="POST"
            data-netlify="true"
            className={classes.formulario}
            onSubmit={handleSubmit}
          >
            <input type="hidden" name="form-name" value="contacto" />

            <motion.input 
              type="text" 
              name="nombre"
              placeholder="Tu nombre"
              required
              className={classes.input}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              viewport={{ once: true }}
            />
            <motion.input 
              type="email"
              name="email"
              placeholder="Tu correo"
              required 
              className={classes.input}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              viewport={{ once: true }}
            />
            <motion.textarea
              name="mensaje"
              placeholder="Tu mensaje"
              required
              className={classes.textarea}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              viewport={{ once: true }}
            />
            <motion.button
              type="submit"
              className={classes.boton}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              viewport={{ once: true }}
            >
              Enviar
            </motion.button>
          </form>
        ) : (
          <motion.p
            className={classes['mensaje-confirmacion']}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            ¡Gracias por tu mensaje! Te responderemos pronto.
          </motion.p>
        )}
        
      </div>
    </section>
  );
};

export default Contacto;